var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5109 10.2734H14.9051H8.05626C6.88426 10.2734 6.29826 11.6896 7.12843 12.5198L13.4523 18.8437C14.4656 19.857 16.1138 19.857 17.127 18.8437L19.5321 16.4386L23.451 12.5198C24.2689 11.6896 23.6829 10.2734 22.5109 10.2734Z",
    fill: "#FFCF01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownlight);
export default __webpack_public_path__ + "static/media/arrowdownlight.62f46685f8c52c9c08adbfa5993c6734.svg";
export { ForwardRef as ReactComponent };